import axios from 'axios'
import { StrapiApi as StrapiApiFactory } from './strapi'

const strapiClient = axios.create({ baseURL: 'https://admin.dillirium.ru/api' })
export const StrapiApi = StrapiApiFactory(strapiClient)
